import { create } from 'zustand';

// printStudio — the HypeFlyer Print Shop's studio panel (2026-10-31): open or
// not, which section, and what the clerk filled in. Opened by the counter (the
// shop dock in a `printshop` room), by tapping the studio screen in the room,
// or by the clerk's `show_studio` tool (worldJob applyRoleOut `studio`) — so
// the options the clerk is talking about are the ones on screen.
//
// `prefill` carries an `id` that changes on every open, so a section applies
// the clerk's fields exactly once per ask (and again if they ask again).
let seq = 0;
export const SECTIONS = ['images', 'posts', 'whois', 'presskit'];

export const usePrintStudio = create((set) => ({
  open: false,
  zone: null,
  section: null,          // null = the four choices
  prefill: null,          // { id, ...fields } for `section`
  // No section: just open (the dock opening keeps wherever it was, or the four
  // choices). A section: turn to it, with the clerk's fields as a fresh prefill.
  show: ({ zone = null, section = null, fill = null } = {}) => set((s) => {
    const turn = SECTIONS.includes(section);
    return {
      open: true,
      zone: zone || s.zone,
      section: turn ? section : s.section,
      prefill: turn ? { id: ++seq, ...(fill || {}) } : s.prefill,
    };
  }),
  go: (section, fill = null) => set({ section: SECTIONS.includes(section) ? section : null, prefill: { id: ++seq, ...(fill || {}) } }),
  close: () => set({ open: false }),
  reset: () => set({ open: false, zone: null, section: null, prefill: null }),
}));

/** The clerk turned the panel (API PrintShopService show_studio → out.studio). */
export function openPrintStudio(zone, studio) {
  const { section, ...fill } = studio || {};
  usePrintStudio.getState().show({ zone, section: section || null, fill });
}
